<template>
  <v-card>
    <v-card-title>
      <span class="text-h5"
        >{{ $t('ITEM.EXECUTE') }} {{ $t('BUTTON.IMPORT') }}</span
      >
    </v-card-title>
    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
          >{{ e[0] }}</v-alert
        >
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="container">
          <div class="large-12 medium-12 small-12 cell">
            <label>
              {{ $t('DOCUMENTS.FILE') }} *
              <input ref="file" type="file" @change="handleFileUpload()" />
            </label>
          </div>
        </div>

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined text @click="$emit('cancel')">{{
              $t('BUTTON.CANCEL')
            }}</v-btn>

            <v-btn
              color="success"
              :disabled="!valid"
              :loading="loading"
              @click="validate"
              >{{ $t('BUTTON.IMPORT') }}</v-btn
            >
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ImportBuildingsWithApartments',

  props: {
    idBuildingComplex: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    types: [],
    error: null,
    file: '',
    valid: true
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.$store.commit('loading', true);

        let url = '/import-buildings-with-apartments';
        let formData = new FormData();
        formData.append('building_complex_id', this.idBuildingComplex);
        formData.append('file', this.file);

        axios
          .post(process.env.VUE_APP_CORE_API + url, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: 'Bearer ' + localStorage.getItem('api_token')
            }
          })
          .then(response => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('success', response.data);
            this.$store.commit('loading', false);
          })
          .catch(error => {
            this.error = error.response;
            this.$store.commit('loading', false);
          });
      }
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    }
  }
};
</script>
